import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { COMBINED_FUNNEL_FORM_INPUT_ENTRIES, FILE_TYPE_FIELDS } from './CodeDestination.constants'
import { FileInput } from '../../../../components/molecules/file-input'
import { Input } from '@dtx-company/shared-components/src/components/atoms/Input/index'
import { PrimaryButton } from '@dtx-company/shared-components/src/components/atoms/Button/index'
import { RootState } from '@dtx-company/inter-app/src/redux/types'
import {
  SocialFormFields,
  SocialFormInputs,
  SocialFormState
} from '@app/pre-build/src/components/OnboardingFlows/Flowtag/OnboardingForms/SocialForm/SocialForm.types'
import { SocialFormInputType } from '@app/pre-build/src/components/OnboardingFlows/Flowtag/OnboardingForms/SocialForm/SocialForm.constants'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { setFileName } from '@dtx-company/inter-app/src/redux/slices/OnboardingSocialsSlice'
import { theme } from '@dtx-company/shared-components/src'
import { useDispatch, useSelector } from 'react-redux'
import React, { useState } from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'

export const CombinedFunnelMobileCodeDestinationInput: React.FC<
  {
    currentDestination: [SocialFormFields, SocialFormInputType]
    disabledNextBtn?: boolean
    onClickNext?: () => void
  } & Omit<SocialFormState, 'socialInputList' | 'handleChange'> & {
      handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    }
> = ({
  currentDestination,
  onClickNext,
  handleChange,
  handleSubmit,
  onSubmit,
  errors,
  values,
  disabledNextBtn
}) => {
  const [destinationInputEventFired, setDestinationInputEventFire] =
    useState<Partial<Record<SocialFormFields, boolean>>>()

  const { imageFileName, pdfFileName } = useSelector(
    (state: RootState) => state.pageReducer.socialFilesReducer
  )
  const dispatch = useDispatch()
  const provider = currentDestination[0]
  const providerData = currentDestination[1]
  const isFileInputType = FILE_TYPE_FIELDS.includes(provider)
  const isPDF = provider === SocialFormFields.PDF
  const acceptValue = isPDF ? 'application/pdf' : 'image/*'
  const fileName = isPDF ? pdfFileName : imageFileName

  const handleDestinationInputEvent = (): void => {
    if (!(destinationInputEventFired && destinationInputEventFired[provider])) {
      events.Flowcode_Combined_Funnel_Mobile_Homepage_Entered_Destination({
        screen: 'code_destination'
      })
      setDestinationInputEventFire(prev => {
        return {
          ...prev,
          [provider]: true
        }
      })
    }
  }

  return (
    <form
      onSubmit={handleSubmit(v =>
        onSubmit(v as SocialFormInputs, COMBINED_FUNNEL_FORM_INPUT_ENTRIES)
      )}
    >
      {isFileInputType ? (
        <FileInput
          accept={acceptValue}
          label=""
          width="100%"
          inputProps={{
            height: '44px'
          }}
          sharedInputProps={{ borderRadius: '0 0 4px 4px' }}
          placeholder={providerData.placeholder}
          fileName={fileName}
          handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            handleChange(e)
            dispatch(
              setFileName({
                type: isPDF ? 'pdf' : 'image',
                fileName: e?.target?.files?.[0]?.name ?? ''
              })
            )
            e.target.value = ''
            handleDestinationInputEvent()
          }}
          clearImage={() => {
            handleChange({
              target: { value: '' }
            } as React.ChangeEvent<HTMLInputElement>)
            dispatch(setFileName({ type: isPDF ? 'pdf' : 'image', fileName: '' }))
          }}
          customStartAdornment={<></>}
        />
      ) : (
        <Input
          backgroundColor={theme.colors.primary.white}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            handleChange(e)
            handleDestinationInputEvent()
          }}
          value={values[provider]}
          placeholder={providerData.placeholder}
          helperText={errors?.[provider]?.message}
          error={errors?.[provider]}
          minWidth="100%"
          height="44px"
          type={providerData.type ?? 'text'}
          startAdornment={
            providerData.inputAdornmentText?.length ? (
              <Text ml="10px" fontSize="16px">
                {providerData.inputAdornmentText}
              </Text>
            ) : undefined
          }
          inputProps={{
            autoCapitalize: 'off',
            ...(providerData.inputAdornmentText?.length && { paddingLeft: '28px' }),
            borderRadius: '0 0 4px 4px'
          }}
          controlled
        />
      )}
      <Box
        position={'fixed'}
        bottom={0}
        right={0}
        left={0}
        width="100%"
        padding={'16px'}
        background="primary.white"
      >
        <PrimaryButton
          width="100%"
          data-testid="next-btn"
          onClick={() => onClickNext?.()}
          disabled={disabledNextBtn || errors?.[provider]}
        >
          Next
        </PrimaryButton>
      </Box>
    </form>
  )
}
